import { db, docFromSnapshot } from '@/firebase';

const state = {
  settings: {}
};

const getters = {
  settings: state => state.settings
};

const actions = {
  async fetchSettings(context) {
    const snap = await db
      .collection('settings')
      .doc('settings')
      .get();
    const settings = docFromSnapshot(snap);

    console.log(settings);

    context.commit('SET_SETTINGS', settings);
  }
};

const mutations = {
  SET_SETTINGS(state, settings) {
    state.settings = settings;
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};
